var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex gap-4 py-4 flex-wrap"},_vm._l((_vm.templates),function(template,index){return _c('m-ritual-template-card',{key:`template-${index}`,attrs:{"ritual-template":template}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }